import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { BROWSE_KEY, SearchUnitNode } from '@components/search_reception_combo_box/_common';
import { SearchReceptionComboBox } from '@components/search_reception_combo_box/mod';
import { FlexibleSearchModel } from '@services/flexible_component/mod';
import { useService } from '@visiba/instantiation';
import { rem } from '@visiba/std';
import styled from 'styled-components';

interface Props {
	component: FlexibleSearchModel;
}

const elements = {
	container: styled.div`
		margin: ${rem(8)} 0;
	`,
};

export function FlexibleSearch({ component }: Props): JSX.Element {
	const analyticService = useService(AnalyticService);

	function handleOpenChange(isOpen: boolean): void {
		if (isOpen) {
			analyticService.trackPageView({
				customTitle: 'SearchReception',
			});
		}
	}

	function handleNodeSelected(node: SearchUnitNode): void {
		const eventAction =
			node.id === BROWSE_KEY ? 'Clicked to enter browse-view from search-view' : 'Selected a reception from search result';

		analyticService.trackEvent(AnalyticCategories.SearchReception, eventAction);
	}

	return (
		<elements.container data-testid='FlexibleSearch'>
			<SearchReceptionComboBox
				placeholder={component.title}
				includeBrowseInResult={true}
				onOpenChange={handleOpenChange}
				onNodeSelected={handleNodeSelected}
			/>
		</elements.container>
	);
}
